export default "__VITE_ASSET__a3bcab23__"